export default __webpack_public_path__ + "static/media/business_admin_tasks.c599191e.svg";